/**
 * Link corti per Facebook / Messenger / WhatsApp.
 *   /g/{slug}  → /comune/{slug}
 *   /fr/{slug} → /frazione/{slug}
 *   /ct/{slug} → /citta/{slug}
 */

import { SITE_ORIGIN } from "./seoMeta";
import { resolveVillageSlug } from "./villageSlug";

const SHORT_KINDS = {
  g: "comune",
  fr: "frazione",
  ct: "citta",
};

const LONG_TO_SHORT = {
  comune: "g",
  village: "g",
  borgo: "g",
  frazione: "fr",
  citta: "ct",
  città: "ct",
  "world-city": "ct",
};

export function shortKindForPathSegment(seg) {
  return LONG_TO_SHORT[String(seg || "").toLowerCase()] || null;
}

export function expandShortPath(pathname) {
  const parts = String(pathname || "/")
    .split("/")
    .filter(Boolean);
  if (parts.length < 2) return null;
  const kind = SHORT_KINDS[parts[0].toLowerCase()];
  if (!kind) return null;
  const slug = resolveVillageSlug(parts[1]) || String(parts[1] || "").toLowerCase();
  if (!slug) return null;
  return `/${kind}/${slug}`;
}

/** Canonical short share URL for a scheda path or absolute URL. */
export function toShortShareUrl(urlOrPath) {
  let path = "/";
  try {
    if (!urlOrPath) {
      if (typeof window !== "undefined") path = window.location.pathname || "/";
    } else {
      const s = String(urlOrPath).trim().split(/\s+/)[0];
      if (/^https?:\/\//i.test(s) || s.startsWith("//")) {
        const u = new URL(s.startsWith("//") ? `https:${s}` : s);
        path = u.pathname || "/";
      } else {
        path = s.startsWith("/") ? s : `/${s}`;
      }
    }
  } catch {
    path = typeof window !== "undefined" ? window.location.pathname || "/" : "/";
  }

  const parts = path.split("/").filter(Boolean);
  if (!parts.length) return `${SITE_ORIGIN}/`;

  if (SHORT_KINDS[parts[0].toLowerCase()] && parts[1]) {
    const slug = resolveVillageSlug(parts[1]) || parts[1].toLowerCase();
    return `${SITE_ORIGIN}/${parts[0].toLowerCase()}/${slug}`;
  }

  const short = shortKindForPathSegment(parts[0]);
  if (short && parts[1]) {
    const slug = resolveVillageSlug(parts[1]) || parts[1].toLowerCase();
    return `${SITE_ORIGIN}/${short}/${slug}`;
  }

  return `${SITE_ORIGIN}${path.startsWith("/") ? path : `/${path}`}`;
}
